import { render, staticRenderFns } from "./SubgrupoProdutoList.vue?vue&type=template&id=4edb2cbb"
import script from "./SubgrupoProdutoList.vue?vue&type=script&lang=js"
export * from "./SubgrupoProdutoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports